import styled from 'styled-components';

export const ImageUI = styled.img<{ isImage?: boolean }>`
  cursor: ${({ isImage }) => (isImage ? 'pointer' : 'default')};
  width: 80px;
  max-height: 60px;
  object-fit: contain;
`;

export const Container = styled.div`
  position: relative;
  margin: -10px;
  min-height: 80px;
  min-width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ColorBadgeWrapper = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  pointer-events: none;
  display: inline-flex;
`;
